import React, { useState, useEffect, useRef } from "react";
import '../assets/css/style.css';

const PersonalizedCarausel = () => {
    const [inView, setInView] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                }
            },
            { threshold: 0.5 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    return (
        <div>
            <div className={`background-image`}>
                <div className="relative custom-padding pt-80 pb-80 xl-screen-padding text-white flex sm:items-start w-full md:w-full xl:w-3/5">
                    <div className="sm:text-left">
                        <h1 className="font-semibold sm:text-left custom-padding-bottom">
                            <span className="text-h2 typewriter-effect">
                                A Personalized Approach to Nutrition
                            </span>
                        </h1>
                        <p className="font-lato text-p text-center sm:text-left pb-4">
                            Imagine waking up each day knowing that the food you eat is perfectly  aligned with your body’s unique needs.
                        </p>
                        <p className="text-p text-center sm:text-left custom-padding-bottom">
                            It's not a dream—it’s possible with personalized nutrition. Our team of experts is here to guide you every step of the way.
                        </p>
                        <p className="text-p text-center sm:text-left custom-padding-bottom">
                            From understanding your specific nutritional requirements to tailoring a plan that fits your lifestyle, we provide a roadmap that’s as unique as you are.
                        </p>
                        <p className="text-center text-p sm:text-left">
                            No more guesswork. No more confusion. Just simple, science-backed <br /> nutrition designed with your health, goals, and life in mind.
                        </p>
                    </div>
                </div>

            </div>

            <div
                ref={sectionRef}
                className="pb-80 pt-80 custom-padding xl-screen-padding flex flex-col sm:flex-row justify-start sm:justify-center items-start sm:items-center gap-8 main-padding-mobile sm:main-padding-mobile"
            >
                <div
                    className={`three-box-animation bg-[#d9cec6] cursor-pointer p-12 sm:p-4 sm:py-24 rounded-lg shadow-[4px_4px_10px_#00000050] text-center flex flex-col items-center justify-center w-full ${inView ? "box-left" : ""}`}
                >
                    <div>
                        <img
                            src={require("../../src/assets/images/circle_small1.png")}
                            className="mb-4 w-16 h-16 sm:w-12 sm:h-12"
                        />
                    </div>
                    <h2 className="font-semibold text-h2-center text-black font-merriweather sm:text-base">
                        PERSONALIZED APPROACH
                    </h2>
                    <p className="mt-2 text-black font-lato text-p-center">
                        Nutritional plan that fits
                        <br /> your lifestyle
                    </p>
                </div>

                <div
                    className={`three-box-animation cursor-pointer p-6 sm:p-4 sm:py-20 padding-extra-box rounded-lg shadow-[2px_2px_5px_#00000050] text-center flex flex-col items-center justify-center w-full ${inView ? "box-center" : ""}`}
                >
                    <div className={`bg-[#0a4d3c] p-2 rounded-full mb-4 ${inView ? "btn-shine" : ""}`}>
                        <img
                            src={require("../../src/assets/images/circle_small2.png")}
                            alt="Nutrigenomics Experts"
                            className="w-16 h-16 sm:w-12 sm:h-12 rounded-sm rotate-on-hover"
                        />
                    </div>

                    <h2 className="font-semibold text-h2-center font-merriweather sm:text-base">
                        QUALIFIED NUTRIGENOMICS <br /> AND CLINICAL DIETITIAN
                    </h2>
                    <p className="mt-0 font-lato text-p-center">
                        Empowering you to
                        make informed <br /> health choices
                    </p>
                </div>
                <div
                    className={`three-box-animation bg-[#d9cec6] cursor-pointer p-12 sm:p-4 sm:py-24 rounded-lg shadow-[4px_4px_10px_#00000050] text-center flex flex-col items-center justify-center w-full ${inView ? "box-right" : ""}`}
                >
                    <div className={`btn-shine ${inView ? "animate-slide-right" : ""}`}>
                        <img
                            src={require("../../src/assets/images/circle_small3.png")}
                            alt="Personalized Approach"
                            className="mb-4 w-16 h-16 sm:w-12 sm:h-12"
                        />
                    </div>
                    <h2 className="font-semibold text-h2-center text-black font-merriweather sm:text-base">
                        ONLINE CONSULTATION
                    </h2>
                    <p className="text-p-center mt-2 text-black font-lato">
                        Responsive, reliable                        <br /> support system
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PersonalizedCarausel;
